var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommentTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector 3",
    d: "M9.65357 7.44324L5.42294 11.3717C5.42294 10.868 5.3625 9.67943 5.12074 8.95417C4.87899 8.22892 2.70325 8.3498 1.4945 6.23449C0.285745 4.11917 2.09887 2.30604 2.70325 1.70167C3.00544 1.0973 7.53825 -0.413643 9.65357 1.70167C11.8293 4.11917 10.5601 6.53668 9.65357 7.44324Z",
    stroke: "black",
    strokeWidth: 1.20875
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommentTwitter);
export default __webpack_public_path__ + "static/media/comment_twitter.80d857dcae5918f6e0c8cff393226322.svg";
export { ForwardRef as ReactComponent };